module.exports = __webpack_public_path__ + "img/img-douyin.94b968ba.png";